// extracted by css-extract-rspack-plugin
var _1 = "mDnYNgyDEVLOypM3PHO0Dg--";
var _2 = "SwPE9-dxJjobITQ3EYpo7Q--";
var _3 = "kMNPOSsOXPd2UY3Y-gFA-Q--";
var _4 = "fWQorg-kkgpqFm2cxIBIrw--";
var _5 = "nR6rT8VNW4PMooXrMhyG-A-- fWQorg-kkgpqFm2cxIBIrw--";
export { _1 as "btnLink", _2 as "native", _3 as "none", _4 as "normal", _5 as "plain" }
